export const EXPERIENCE_TYPES: any = {
  'curbside': 'CURBSIDE',
  'in-store-pickup': 'IN_STORE_PICKUP',
  'ship-to-store': 'SHIP_TO_STORE',
  'delivery': 'DELIVERY',
  'shipping': 'SHIPPING'
};

export const ALL_EXPERIENCE_TYPES: any = {
  "curbside": "CURBSIDE",
  "in-store-pickup": "IN_STORE_PICKUP",
  "ship-to-store": "SHIP_TO_STORE",
  "delivery": "DELIVERY",
  "shipping": "SHIPPING"
};

export const SHIP_TO_STORE = {
  "in-transit-status": "IN_TRANSIT",
};

export const EXPERIENCE_TYPE = {
  SHIP_TO_STORE: "ship-to-store",
  CURBSIDE: "curbside",
  IN_STORE_PICKUP: "in-store-pickup",
  DELIVERY: "delivery",
  SHIPPING: "shipping"
};
